import { useTranslation } from "react-i18next";
import type { FlashcardContent } from "../content-types";
import { Prompt } from "./shared";
import { GlossableText, isLanguageFramework } from "./glossable-text";
import type { QuestionRendererProps } from "./types";

/** Self-graded. Front shows; the back is revealed when the learner checks, then
 *  they mark "Got it / Missed" in the session footer. */
export function FlashcardRenderer({ content, revealed, frameworkSlug, translateAnswers }: QuestionRendererProps) {
  const { t } = useTranslation();
  const c = content as unknown as FlashcardContent;
  const enableGloss = isLanguageFramework(frameworkSlug);
  const enableAnswerGloss = enableGloss && !!translateAnswers;
  return (
    <div>
      <Prompt>{enableGloss ? <GlossableText text={c.front} context={c.front} /> : c.front}</Prompt>
      {revealed ? (
        <div className="mt-4 whitespace-pre-wrap rounded-xl bg-brand-50 p-4 text-ink">
          {enableAnswerGloss ? <GlossableText text={c.back} context={c.front} /> : c.back}
        </div>
      ) : (
        <p className="mt-4 text-sm text-ink-faint">{t("Think of the answer, then check to reveal.")}</p>
      )}
    </div>
  );
}
